import React, { useState, useEffect } from 'react';
// Context
import { useCTALogClassesData } from '../../../../context/CTALogClassesContext';
// Modules
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
// Components
import Loading from '../../../../components/loading/Loading';
import { toastSuccess, toastError } from '../../../../components/feedback/Feedback';
// Form
import useInput from '../../../../components/form/hooks/useInput';
import DefaultInput from '../../../../components/form/inputs/DefaultInput';
import DefaultSelect from '../../../../components/form/inputs/DefaultSelect';
import { isNotEmpty, isNotNullOrUndefinedOrEmpty } from '../../../../components/form/validator/ValidatorRules';
import { isMandatoryMessage } from '../../../../components/form/validator/ValidatorMessages';
// Utils
import { ApplicationOptions } from '../../../../utils/Enums';
// Actions
import { saveclasses as CTALogClassSave } from '../../../../actions/ctalogs';

export default function CTALogClassForm({ CTALogClass, handleCloseModal }) {
  // Form
  const {
    value: nameValue,
    isValid: nameIsValid,
    hasError: nameHasError,
    valueChangeHandler: nameChangeHandler,
    inputBlurHandler: nameBlurHandler,
  } = useInput(isNotEmpty);
  const {
    value: applicationValue,
    isValid: applicationIsValid,
    hasError: applicationHasError,
    valueChangeHandler: applicationChangeHandler,
    inputBlurHandler: applicationBlurHandler,
  } = useInput(isNotNullOrUndefinedOrEmpty);

  let formIsValid = false;

  if (nameIsValid && applicationIsValid) {
    formIsValid = true;
  }

  // Context
  const { state, dispatch } = useCTALogClassesData();

  // State
  const [isLoading, setIsLoading] = useState(false);

  // useEffect
  useEffect(
    () => {
      if (CTALogClass) {
        nameChangeHandler(CTALogClass.name);

        const defaultApplicationOption = ApplicationOptions.find((option) => option.id === CTALogClass.applicationId);

        applicationChangeHandler(defaultApplicationOption);
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Methods
  const validateAllFormInputs = () => {
    nameBlurHandler();
    nameChangeHandler(nameValue);
    applicationBlurHandler();
    applicationChangeHandler(applicationValue);
  };

  const saveCTALogClass = async () => {
    setIsLoading(true);

    await CTALogClassSave({
      data: {
        ...CTALogClass,
        name: nameValue,
        applicationId: applicationValue.id,
      },
      success: (data) => {
        toastSuccess('A lista de classes CTA foi atualizada com sucesso');
        setIsLoading(false);
        handleCloseModal();
        dispatch({
          type: 'SET_RELOAD',
          payload: !state.reload,
        });
      },
      error: (error) => {
        toastError('Ocorreu um erro ao submeter a classe');
        setIsLoading(false);
      },
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!formIsValid) {
      validateAllFormInputs();
      return;
    }

    saveCTALogClass();
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col>
            <DefaultInput
              label={'Nome'}
              name={'name'}
              required={true}
              type={'text'}
              value={nameValue}
              onChange={nameChangeHandler}
              onBlur={nameBlurHandler}
              hasError={nameHasError}
              errorMessage={isMandatoryMessage}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <DefaultSelect
              label={'Aplicação'}
              instanceId={'applicationSelect'}
              required={true}
              options={ApplicationOptions}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.name}
              defaultValue={null}
              value={applicationValue}
              onChange={applicationChangeHandler}
              onBlur={applicationBlurHandler}
              hasError={applicationHasError}
              errorMessage={isMandatoryMessage}
            />
          </Col>
        </Row>
        <Row>
          <Col className="text-end">
            <Button type={'submit'}>Submeter</Button>
          </Col>
        </Row>
      </Form>
      {isLoading && <Loading label={'A carregar...'} />}
    </>
  );
}
